export const CASH = 'CASH';
export const CHEQUE = 'CHKL';

export const hardcodeDropdown = {
    paymodeTypes: [
        {
            label: `Cheque`,
            value: CHEQUE
        },
        {
            label: `Cash`,
            value: CASH
        },
    ],
};

// export const getStatusChipInfo = (row) => {
//     const { approvalStatus, receiptStatus } = row;

//     switch (true) {

//         case approvalStatus?.includes('PENDING'): {
//             const isL1 = approvalStatus?.includes('L1');
//             const isL2 = approvalStatus?.includes('L2');
//             const text = `Pending at ${isL1 ? 'L1' : isL2 ? 'L2' : 'L3'}`;
//             return {
//                 text: text,
//                 bgColor: "#FFEDC8",
//                 textColor: "#A17217"
//             }
//         }

//         case approvalStatus?.includes('APPROVED'): {
//             return {
//                 text: 'Approved',
//                 bgColor: "#BBE2CE",
//                 textColor: "#0B442D"
//             }
//         }

//         case approvalStatus?.includes('SUBMITTED'): {
//             return {
//                 text: 'SUBMITTED',
//                 bgColor: "#BBE2CE",
//                 textColor: "#0B442D"
//             }
//         }

//         case approvalStatus?.includes('CORRECTION'): {
//             return {
//                 text: 'ACTION NEEDED',
//                 bgColor: "#F5F5F5",
//                 textColor: "#262626"
//             }
//         }
//     }
// }

export const rejectionHandler = async (rejectRequest) => {
    const { setUpdateStatusInfo, isRemarkMandatory, approvalAction } = rejectRequest || {}
    setUpdateStatusInfo({
        dialogInfo: rejectRequest?.dialogInfo ?? { subHeading: "" },
        isRemarkMandatory: isRemarkMandatory || false,
        updatedOn: rejectRequest?.updatedOn,
        updatedBy: rejectRequest?.updatedBy,
        approvalAction,
        isUpdatedDetailRequired: rejectRequest?.isUpdatedDetailRequired || false
    })
}